import { render, staticRenderFns } from "./ChangeMaterialOrderState.vue?vue&type=template&id=60d31f1b&scoped=true"
import script from "./ChangeMaterialOrderState.vue?vue&type=script&lang=js"
export * from "./ChangeMaterialOrderState.vue?vue&type=script&lang=js"
import style0 from "./ChangeMaterialOrderState.vue?vue&type=style&index=0&id=60d31f1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d31f1b",
  null
  
)

export default component.exports